import { createApp } from 'vue';
import CookieConsent from 'vue@/components/cookieConsent.vue';
import Global from 'vue@/plugin/global'

const vueInstance = createApp({
    components: {
      CookieConsent
    },
    template: '<cookie-consent />'
  }).use(Global).mount('#cookie-wrapper');

  export default vueInstance;
